import type { FaireProductEntity } from "../../entity_types/product";

export const p_kck7b89s3k: FaireProductEntity = {
  token: "p_kck7b89s3k",
  type: "product",
  name: "Striped Waterproof Canvas Large Capacity Tote Bag",
  brandToken: "b_11782mgvt5",
  brandName: "LA Society",
  imageUrl:
    "https://cdn.faire.com/fastly/aa7461aa45e336443c9524a85820eb4321dc16ba1119991991def8d4a5458746.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07381d57cb00adc74e7356cf63138e4c0952a3412bb37c67fda3396ac60ab092.png",
    "https://cdn.faire.com/fastly/984d1fb69fe11000b0cb83cab135e788dd0ffd87649259d4a75d3351ee7baec2.jpeg",
  ],
  priceDollars: 13.55,
  description:
    "Material: 100%Polyester\nSize Chart (INCH)\t\t\t\nSize\t                   Length\t   Height\t         Width\nONE SIZE\t20.5–20.9\t14.2–14.4\t6.9–7.1\n\nStyle\tCasual,Daily\nPattern\tStriped\t\nOccasion\tBeach,Vacation\nDetails\tColorblock",
  tags: [],
  msrpDollars: 27.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:57.970Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
